// extracted by mini-css-extract-plugin
export default {"chips":"ManualBookingDesk_chips__BXtrw"};